import type { Contents } from '@/wabunka-src/common/features/Featured/models/featured/featured';

import type { MicroCMSImage } from 'microcms-js-sdk';

export type DestinationThemeContent = Contents[number];

/**
 * MicroCMS destination-theme content response structure
 * Endpoint: en-featured/{destination}-{theme}
 */
export interface DestinationThemeContentResponse {
  id: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  revisedAt: string;
  type: string[];
  titleEn: string;
  backgroundWideMedias: MicroCMSImage[];
  backgroundTallMedias: MicroCMSImage[];
  destinationTags: string[];
  themeTags: string[];
  summary: string;
  ogImage?: MicroCMSImage;
  contents: DestinationThemeContent[];
  contentsBottom?: DestinationThemeContent[];
}

export type DestinationThemeContentViewModel = DestinationThemeContentResponse;

export const createDefaultDestinationThemeContent = (): DestinationThemeContentResponse => ({
  id: '',
  createdAt: '',
  updatedAt: '',
  publishedAt: '',
  revisedAt: '',
  type: [],
  titleEn: '',
  backgroundWideMedias: [],
  backgroundTallMedias: [],
  destinationTags: [],
  themeTags: [],
  summary: '',
  contents: [],
});
